<template>
  <v-expansion-panel>
    <v-expansion-panel-header style="padding: 10px !important">
      <div class="title-left">
        <v-checkbox
          v-if="isDefaultSection"
          :name="`check-${section.tag}`"
          v-model="section.checked"
          color="#41a982"
          class="section-checkbox"
          :disabled="isDefaultSection"
          style="opacity: 0.3"
        ></v-checkbox>
        <v-checkbox
          v-else
          :name="`check-${section.tag}`"
          v-model="section.checked"
          color="#41a982"
          class="section-checkbox"
          @change="changeCheckSection"
          @click.stop
        ></v-checkbox>

        <span class="media-count">[{{ mediaCount }}]</span>

        <span class="section-title">{{ section.description.toUpperCase() }}</span>

        <div v-if="isUploadingInSection" class="upload-indicator">
          <v-progress-circular indeterminate color="primary" size="20" width="3"></v-progress-circular>
          <span class="upload-text">Processando...</span>
        </div>

        <v-menu v-if="section.id" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon size="small" variant="text" @click.stop class="section-menu-btn" v-bind="attrs" v-on="on">
              <v-icon size="20">mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item>
              <v-list-item-title @click="modals.edit.isOpen = true">
                <v-icon size="16" class="me-2">mdi-pencil</v-icon>
                Renomear
              </v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-title @click="modals.delete.isOpen = true">
                <v-icon size="16" class="me-2">mdi-delete</v-icon>
                Desativar seção
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-expansion-panel-header>

    <v-expansion-panel-content class="media-grid-container">
      <div class="add-media-row">
        <div class="capture-box capture-box--add">
          <div
            v-if="parameterMediaCameraType && parameterMediaCameraType === 'alternative'"
            class="capture-box__content"
            @click="openAlternativeTakePhoto({ order: nextOrder, position: 'first' })"
          >
            <div>
              <v-icon size="35">mdi-camera</v-icon>
            </div>
          </div>
          <label v-else :for="`uploadFile-${section.tag}`">
            <div class="capture-box__content">
              <input
                style="display: none"
                accept="image/*,video/mp4,.mp4,.heic,.heif"
                type="file"
                class="input-upload"
                :id="`uploadFile-${section.tag}`"
                multiple
                @change="onFileChange($event, { order: nextOrder, position: 'first' })"
              />
              <v-icon size="40" color="#777">mdi-camera</v-icon>
            </div>
          </label>
        </div>
      </div>

      <div class="media-grid">
        <div
          v-for="(item, itemIndex) in section.items"
          :key="'item-' + section.tag + '-' + item?.first?.id + item?.second?.id + '-' + itemIndex"
          class="mt-3 media-section-items"
        >
          <div
            class="media-item"
            :class="{
              'has-image': !!item.first
            }"
          >
            <template v-if="item.first">
              <v-progress-linear v-if="ordersLoading.includes(item.order)" indeterminate color="primary" size="20" width="3"></v-progress-linear>
              <template v-if="item.first.type?.includes('video/')">
                <div class="video-thumbnail-container" @click.stop="openModalVideoPlayer(item.first)" :data-video-src="getMediaUrl(item.first)">
                  <video class="media-thumb media-thumb--video" playsinline>
                    <source :src="getMediaUrl(item.first)" type="video/mp4" />
                  </video>
                  <div class="video-play-icon">
                    <v-icon size="48" color="white">mdi-play-circle</v-icon>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="media-thumb">
                  <img class="viewer-preview-helper" :original="getMediaUrl(item.first)" />
                  <v-img :src="getMediaUrl(item.first)" alt="Foto" height="214px" />
                </div>
              </template>
              <div v-if="item.first?.id > 0" class="media-date">{{ formatDateTime(item.first.createdAt) }}</div>
              <div v-if="item.first?.id > 0" class="media-actions">
                <v-btn
                  size="small"
                  variant="flat"
                  @click.stop="openModalEditMedia(item.first, item.order, false)"
                  style="padding: 0px; min-width: 35px; width: 35px"
                >
                  <v-icon color="#ED8936">mdi-pencil</v-icon>
                </v-btn>

                <v-btn
                  size="small"
                  variant="flat"
                  @click.stop="openModalDeleteMedia(item.first, item.order, false)"
                  style="padding: 0px; min-width: 35px; width: 35px"
                >
                  <v-icon color="#F56565">mdi-trash-can-outline</v-icon>
                </v-btn>
              </div>
            </template>
            <template v-else>
              <div class="capture-box capture-box--inner">
                <div
                  v-if="parameterMediaCameraType && parameterMediaCameraType === 'alternative'"
                  class="capture-box__content"
                  @click="openAlternativeTakePhoto({ order: item.order, position: 'first' })"
                >
                  <div>
                    <v-icon size="35">mdi-camera</v-icon>
                  </div>
                </div>
                <label v-else :for="`uploadFile-${item.order}-first`">
                  <div class="capture-box__content">
                    <input
                      style="display: none"
                      accept="image/*,video/mp4,.mp4,.heic,.heif"
                      type="file"
                      class="input-upload"
                      :id="`uploadFile-${item.order}-first`"
                      @change="onFileChange($event, { order: item.order, position: 'first' })"
                    />
                    <v-icon size="40" color="#777">mdi-camera</v-icon>
                  </div>
                </label>
              </div>
            </template>
          </div>

          <div
            class="media-item"
            :class="{
              'has-image': !!item.second
            }"
          >
            <template v-if="item.second">
              <v-progress-linear v-if="ordersLoading.includes(item.order)" indeterminate color="primary" size="20" width="3"></v-progress-linear>
              <template v-if="item.second.type?.includes('video/')">
                <div class="video-thumbnail-container" @click.stop="openModalVideoPlayer(item.second)" :data-video-src="getMediaUrl(item.second)">
                  <video class="media-thumb media-thumb--video" playsinline>
                    <source :src="getMediaUrl(item.second)" type="video/mp4" />
                  </video>
                  <div class="video-play-icon">
                    <v-icon size="48" color="white">mdi-play-circle</v-icon>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="media-thumb">
                  <img class="viewer-preview-helper" :original="getMediaUrl(item.second)" />
                  <v-img :src="getMediaUrl(item.second)" alt="Foto" height="214px" />
                </div>
              </template>
              <div v-if="item.second?.id > 0" class="media-date">{{ formatDateTime(item.second.createdAt) }}</div>
              <div v-if="item.second?.id > 0" class="media-actions">
                <v-btn
                  size="small"
                  variant="flat"
                  @click.stop="openModalEditMedia(item.second, item.order, true)"
                  style="padding: 0px; min-width: 35px; width: 35px"
                >
                  <v-icon color="#ED8936">mdi-pencil</v-icon>
                </v-btn>
                <v-btn
                  size="small"
                  variant="flat"
                  @click.stop="openModalDeleteMedia(item.second, item.order, true)"
                  style="padding: 0px; min-width: 35px; width: 35px"
                >
                  <v-icon color="#F56565">mdi-trash-can-outline</v-icon>
                </v-btn>
              </div>
            </template>
            <template v-else>
              <div class="capture-box capture-box--inner">
                <div
                  v-if="parameterMediaCameraType && parameterMediaCameraType === 'alternative'"
                  class="capture-box__content"
                  @click="openAlternativeTakePhoto({ order: item.order, position: 'second' })"
                >
                  <div>
                    <v-icon size="35">mdi-camera</v-icon>
                  </div>
                </div>
                <label v-else :for="`uploadFile-${item.order}-second`">
                  <div class="capture-box__content">
                    <input
                      style="display: none"
                      accept="image/*,video/mp4,.mp4,.heic,.heif"
                      type="file"
                      class="input-upload"
                      :id="`uploadFile-${item.order}-second`"
                      @change="onFileChange($event, { order: item.order, position: 'second' })"
                    />
                    <v-icon size="40" color="#777">mdi-camera</v-icon>
                  </div>
                </label>
              </div>
            </template>
          </div>
        </div>
      </div>
    </v-expansion-panel-content>

    <ModalDeleteSection
      :is-active="modals.delete.isOpen"
      :section="section"
      :loading="modals.delete.loading"
      @close="modals.delete.isOpen = false"
      @save="saveModalDelete"
    />

    <ModalEditSection
      :is-active="modals.edit.isOpen"
      :section="section"
      :loading="modals.edit.loading"
      @close="modals.edit.isOpen = false"
      @save="saveModalEdit"
    />

    <ModalDeleteMedia
      :is-active="modals.deleteMedia.isOpen"
      :loading="modals.deleteMedia.loading"
      @close="closeModalDeleteMedia"
      @save="saveModalDeleteMedia"
    />

    <ModalEditMedia
      :is-active="modals.editMedia.isOpen"
      :media="modals.editMedia.media"
      :loading="modals.editMedia.loading"
      @close="closeModalEditMedia"
      @save="saveModalEditMedia"
    />

    <ModalVideoPlayer :is-active="modals.videoPlayer.isOpen" :video-url="modals.videoPlayer.videoUrl" @close="closeModalVideoPlayer" />

    <TakePhotoDialog
      v-if="modals.takePhotoDialog.modal"
      :component="modals.takePhotoDialog.component"
      @media-captured="mediaCapturedAlternative"
      @close="closeAlternativeTakePhoto"
    />
  </v-expansion-panel>
</template>

<script>
import api from '@/plugins/axios';
import heic2any from 'heic2any';

import TakePhotoDialog from '../Dialogs/TakePhotoDialog';
import ModalDeleteSection from './MediaSection/ModalDeleteSection';
import ModalEditSection from './MediaSection/ModalEditSection';
import ModalDeleteMedia from './MediaSection/ModalDeleteMedia';
import ModalEditMedia from './MediaSection/ModalEditMedia';
import ModalVideoPlayer from '../../Common/ModalVideoPlayer';

export default {
  components: { ModalDeleteSection, ModalEditSection, ModalDeleteMedia, ModalEditMedia, ModalVideoPlayer, TakePhotoDialog },
  emits: ['refresh-data', 'upload-file', 'order-loading'],
  props: {
    section: {
      type: Object,
      required: true
    },
    ordersLoading: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      isSelected: false,
      isUploadingInSection: false,
      isOrganizeItems: false,
      modals: {
        delete: {
          isOpen: false,
          loading: false
        },
        edit: {
          isOpen: false,
          loading: false
        },
        deleteMedia: {
          isOpen: false,
          media: null,
          itemOrder: null,
          isSecond: null,
          loading: false
        },
        editMedia: {
          isOpen: false,
          media: null,
          itemOrder: null,
          isSecond: null,
          loading: false
        },
        videoPlayer: {
          isOpen: false,
          videoUrl: null
        },
        takePhotoDialog: {
          modal: false,
          component: null,
          index: null,
          positionInfo: null
        }
      }
    };
  },
  computed: {
    service_order() {
      return this.$store.getters['ServiceOrder/intialDetails'];
    },
    mediaCount() {
      let count = 0;
      this.section.items.forEach((item) => {
        if (item.first) count += 1;
        if (item.second) count += 1;
      });
      return count;
    },
    isDefaultSection() {
      return !this.section.id;
    },
    nextOrder() {
      if (this.section.items.length === 0) return 1;
      const maxOrder = Math.max(...this.section.items.map((item) => item.order));
      return maxOrder + 1;
    },
    status() {
      return this.$store.getters['ServiceOrder/status'];
    },
    parameterMediaCameraType() {
      return this.$store.getters['Auth/parameters']?.find((parameter) => parameter.name === 'media_camera_type')?.value;
    }
  },
  methods: {
    getMediaUrl(media) {
      return media.src;
    },
    formatDateTime(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return `${date.toLocaleDateString()} às ${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
    },
    async saveModalDelete() {
      this.modals.delete.loading = true;

      try {
        await this.$store.dispatch('ServiceOrder/removeSection', this.section.id);
        this.modals.delete.isOpen = false;
        this.$emit('refresh-data');
      } finally {
        this.modals.delete.loading = false;
      }
    },
    async saveModalEdit(description) {
      this.modals.edit.loading = true;

      try {
        await this.$store.dispatch('ServiceOrder/renameSection', { sectionId: this.section.id, description });
        this.modals.edit.isOpen = false;
        this.$emit('refresh-data');
      } finally {
        this.modals.edit.loading = false;
      }
    },
    openModalDeleteMedia(media, itemOrder, isSecond) {
      this.modals.deleteMedia.isOpen = true;
      this.modals.deleteMedia.media = media;
      this.modals.deleteMedia.itemOrder = itemOrder;
      this.modals.deleteMedia.isSecond = isSecond;
    },
    closeModalDeleteMedia() {
      this.modals.deleteMedia.isOpen = false;
      this.modals.deleteMedia.media = null;
      this.modals.deleteMedia.itemOrder = null;
      this.modals.deleteMedia.isSecond = null;
    },
    async saveModalDeleteMedia() {
      this.modals.deleteMedia.loading = true;

      try {
        await this.$store.dispatch('ServiceOrder/removeSectionMedia', this.modals.deleteMedia.media.id);

        const sectionMediaIndex = this.section.items.findIndex(({ order }) => order === this.modals.deleteMedia.itemOrder);

        if (sectionMediaIndex !== -1) {
          this.section.items[sectionMediaIndex][this.modals.deleteMedia.isSecond ? 'second' : 'first'] = null;
        }

        if (!this.section.items[sectionMediaIndex]?.first && !this.section.items[sectionMediaIndex]?.second) {
          this.section.items.splice(sectionMediaIndex, 1);
        }

        this.closeModalDeleteMedia();
      } finally {
        this.modals.deleteMedia.loading = false;
      }
    },
    openModalEditMedia(media, itemOrder, isSecond) {
      this.modals.editMedia.isOpen = true;
      this.modals.editMedia.media = media;
      this.modals.editMedia.itemOrder = itemOrder;
      this.modals.editMedia.isSecond = isSecond;
    },
    closeModalEditMedia() {
      this.modals.editMedia.isOpen = false;
      this.modals.editMedia.media = null;
      this.modals.editMedia.itemOrder = null;
      this.modals.editMedia.isSecond = null;
    },
    async saveModalEditMedia(form) {
      this.modals.editMedia.loading = true;

      try {
        const { observation, visible } = form;
        const isToUseVisibleField = !!(visible === true || visible === false);

        await api.patch(`/service_order/${this.service_order.id}/photo/${this.modals.editMedia.media.id}`, {
          observation,
          ...(isToUseVisibleField ? { visible } : {})
        });

        const item = this.section.items.find(({ order }) => order === this.modals.editMedia.itemOrder);

        if (item) {
          item[this.modals.editMedia.isSecond ? 'second' : 'first'].observation = observation;

          if (isToUseVisibleField) {
            item[this.modals.editMedia.isSecond ? 'second' : 'first'].visible = visible;
          }
        }

        this.modals.editMedia.isOpen = false;
        this.modals.editMedia.media = null;
        this.modals.editMedia.itemOrder = null;
        this.modals.editMedia.isSecond = null;
      } finally {
        this.modals.editMedia.loading = false;
      }
    },
    async onFileChange(event, data) {
      if (this.status === 'finished' || this.status === 'canceled') {
        return;
      }

      this.isUploadingInSection = true;

      try {
        const isSecond = data.position === 'second';

        const promises = Array.from(event.target.files).map(async (fileOriginal, index) => {
          const actualOrder = data.order + index;

          const file = await this.convertHeicToJpeg(fileOriginal);

          this.$emit('order-loading', actualOrder);

          const tag = `${this.section.tag}_${actualOrder}${isSecond ? '_second' : ''}`;

          this.$emit('upload-file', file, tag, { component: this.section.tag, index: actualOrder, second: isSecond });

          const item = this.section.items.find(({ order }) => order === actualOrder);

          if (item) {
            const mediaData = {
              id: 0,
              tag,
              src: URL.createObjectURL(file),
              observation: null,
              createdAt: new Date(),
              type: file.type,
              visible: true
            };
            item[isSecond ? 'second' : 'first'] = mediaData;
            return;
          }

          const mediaData = {
            id: 0,
            tag,
            src: URL.createObjectURL(file),
            observation: null,
            createdAt: new Date(),
            type: file.type,
            visible: true
          };

          const newItem = {
            order: actualOrder,
            [isSecond ? 'second' : 'first']: mediaData,
            [isSecond ? 'first' : 'second']: null
          };

          this.section.items.unshift(newItem);
        });

        await Promise.all(promises);
      } finally {
        this.isUploadingInSection = false;
      }
    },
    async convertHeicToJpeg(fileOriginal) {
      try {
        const isHeicByType =
          fileOriginal.type === 'image/heic' ||
          fileOriginal.type === 'image/heif' ||
          fileOriginal.type === 'image/x-heic' ||
          fileOriginal.type === 'image/x-heif';

        const isHeicByExtension =
          fileOriginal.name && (fileOriginal.name.toLowerCase().endsWith('.heic') || fileOriginal.name.toLowerCase().endsWith('.heif'));

        if (!isHeicByType && !isHeicByExtension) {
          return fileOriginal;
        }

        const convertedBlob = await heic2any({
          blob: fileOriginal,
          quality: 0.8,
          toType: 'image/jpeg'
        });

        const finalBlob = Array.isArray(convertedBlob) ? convertedBlob[0] : convertedBlob;

        const convertedFile = new File([finalBlob], `${Date.now()}_converted.jpg`, {
          type: 'image/jpeg'
        });

        return convertedFile;
      } catch (error) {
        console.error('Erro ao converter HEIC:', error);

        this.$toast.warning('Não foi possível converter o arquivo HEIC. Tentando enviar formato original...', {
          position: 'bottom-right',
          duration: 3000
        });

        const fallbackFile = new File([fileOriginal], `${Date.now()}_heic_fallback.jpg`, {
          type: 'image/jpeg'
        });

        return fallbackFile;
      }
    },
    async changeCheckSection(value) {
      await this.$store.dispatch('ServiceOrder/checkSection', { sectionId: this.section.id, isChecked: value === true });
    },
    openModalVideoPlayer(media) {
      this.modals.videoPlayer.isOpen = true;
      this.modals.videoPlayer.videoUrl = this.getMediaUrl(media);
    },
    closeModalVideoPlayer() {
      this.modals.videoPlayer.isOpen = false;
      this.modals.videoPlayer.videoUrl = null;
    },
    openAlternativeTakePhoto(positionInfo) {
      this.modals.takePhotoDialog = {
        modal: true,
        component: 'checklist',
        index: false,
        positionInfo
      };
    },
    closeAlternativeTakePhoto() {
      this.modals.takePhotoDialog = {
        modal: false,
        component: null,
        index: null,
        positionInfo: null
      };
    },
    mediaCapturedAlternative(payload) {
      const file = new File([payload.blob], `${Date.now()}.${payload.type === 'photo' ? 'jpg' : 'mp4'}`, { type: payload.blob.type });

      const actualOrder = this.modals.takePhotoDialog.positionInfo.order;
      const isSecond = this.modals.takePhotoDialog.positionInfo.position === 'second';

      this.$emit('order-loading', actualOrder);

      const tag = `${this.section.tag}_${actualOrder}${isSecond ? '_second' : ''}`;

      this.$emit('upload-file', file, tag, { component: this.section.tag, index: actualOrder, second: isSecond });

      const item = this.section.items.find(({ order }) => order === actualOrder);

      if (item) {
        const mediaData = {
          id: 0,
          tag,
          src: URL.createObjectURL(file),
          observation: null,
          createdAt: new Date(),
          type: file.type,
          visible: true
        };
        item[isSecond ? 'second' : 'first'] = mediaData;
        return;
      }

      const mediaData = {
        id: 0,
        tag,
        src: URL.createObjectURL(file),
        observation: null,
        createdAt: new Date(),
        type: file.type,
        visible: true
      };

      const newItem = {
        order: actualOrder,
        [isSecond ? 'second' : 'first']: mediaData,
        [isSecond ? 'first' : 'second']: null
      };

      this.section.items.unshift(newItem);

      this.closeAlternativeTakePhoto();
    }
  }
};
</script>

<style lang="scss">
.v-expansion-panel-title {
  padding: 0px;
  background-color: #f4f4f4;
  padding-right: 10px;
}

.title-left {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  width: 100%;
}

.section-title {
  flex: 1;
}

.section-checkbox {
  flex-shrink: 0;
  margin-top: 0;
  height: 32px;

  :deep(.v-icon) {
    color: #41a982 !important; // Cor verde para mostrar que está sempre ativo
  }

  &.checkbox-disabled {
    pointer-events: none;

    :deep(.v-selection-control__input) {
      opacity: 0.8;
    }

    :deep(.v-icon) {
      color: #41a982 !important; // Cor verde para mostrar que está sempre ativo
    }
  }
}

.media-count {
  color: #666;
  font-size: 0.9em;
  font-weight: 500;
  margin-left: auto;
}

.section-menu-btn {
  margin-left: 8px;
  opacity: 0.7;

  &:hover {
    opacity: 1;
  }
}

.media-grid-container {
  border-top: 3px solid #ddd !important;
  padding-top: 10px;
}

.v-expansion-panel-content__wrap {
  padding: 10px !important;
}

.media-grid-container :deep(.v-expansion-panel-text__wrapper) {
  padding: 15px 10px !important;
  border-top: 3px solid #ddd !important;
  background-color: #f6f6f6 !important;
}

.media-grid {
  gap: 10px;

  .media-section-items {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;

    .media-item {
      position: relative;
      height: 214px;
      border-radius: 8px;
      overflow: hidden;
      background: transparent;
      width: 100%;
    }
  }
}

.capture-box {
  text-align: center;
  border: 1px dashed rgba(0, 0, 0, 0.4);
  border-radius: 8px;
  height: -webkit-fill-available;
  cursor: pointer;
  background: #fafafa;
  transition: all 0.2s ease;
}

.capture-box--inner {
  height: 214px;
}

.capture-box--add {
  width: 100%;
  height: 60px;
}

.capture-box__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 8px;
}

.add-text {
  font-size: 14px;
  font-weight: 500;
}

.add-media-row {
  margin-bottom: 15px;
}

.media-item {
  position: relative;
  height: 214px;
  border-radius: 8px;
  overflow: hidden;
  background: transparent;
  width: 100%;
}

.media-item.has-image {
  background: #000;
}

.media-item.not-synced {
  border: 4px #fb8c00 solid;
}

.media-thumb {
  width: 100%;
  height: 100%;

  img {
    object-fit: cover;
  }
}

video.media-thumb {
  background: #000;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.media-thumb--video {
  cursor: pointer;
}

:deep(.viewer-image) {
  cursor: pointer;
}

.video-thumbnail-container {
  position: relative;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.video-play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.media-date {
  position: absolute;
  left: 6px;
  right: 6px;
  bottom: 6px;
  color: #fff;
  background: rgba(0, 0, 0, 0.7);
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  text-align: center;
}

.media-actions {
  position: absolute;
  left: 6px;
  top: 6px;
  right: 6px;
  display: flex;
  justify-content: space-between !important;
  pointer-events: auto;
  z-index: 99999;
}

.info-message {
  background-color: rgb(238, 238, 238);
  padding: 10px;
  font-size: 13px;
  text-align: center;
  border-radius: 6px;
  margin-top: 10px;
  color: #666;
}

.chooser-grid {
  padding: 20px;
  background-color: #eee;

  .chooser-grid-title {
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0.5px;
    color: #000;
    text-align: center;
    margin-bottom: 16px;
    background-color: #fff;
    padding: 10px;
    border-radius: 8px;
  }

  .chooser-grid-top {
    display: flex;
    flex-direction: row;
    gap: 14px;
    margin-bottom: 16px;

    .chooser-grid-item {
      height: 180px;
    }
  }

  .chooser-grid-bottom {
    .chooser-grid-item {
      height: 110px;
    }
  }

  .chooser-grid-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    border: 1px dashed rgba(0, 0, 0, 0.4);
    border-radius: 8px;
    cursor: pointer;
    background: #fafafa;
    width: 100%;

    .chooser-grid-item-icon {
      background-color: #eee;
      border-radius: 10%;
      padding: 10px;
    }

    .chooser-grid-item-title {
      margin-top: 12px;
    }
  }
}

.video-player {
  width: 100%;
  height: auto;
  background: #000;
}

.upload-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  padding: 6px 12px;
  background-color: rgba(25, 118, 210, 0.1);
  border-radius: 16px;
  border: 1px solid rgba(25, 118, 210, 0.3);

  .upload-text {
    font-size: 12px;
    font-weight: 500;
    color: #1976d2;
  }
}
</style>
